import React from 'react'
import Firebase from 'firebase'

import { getDocFromDoc } from './db_util'
import Loading from '../views/misc/Loading'
import Error from '../views/misc/Error'

const withUser = (WrappedComponent) => {

  class componentWithUser extends React.Component {

    constructor(props) {
      super(props)
      this.state = {
        loading: true,
        error: null,
        user: null,
      }
    }

    componentWillMount() {
      this._subscribeToUserChanges()
    }

    componentWillReceiveProps() {
      this._subscribeToUserChanges()
    }

    _subscribeToUserChanges = () => {
      if (this.unsubscribe) {
        this.unsubscribe()
      }
      let currentUser = Firebase.auth().currentUser
      if (currentUser) {
        this.unsubscribe = Firebase.firestore().collection('users').doc(currentUser.uid).onSnapshot( snapshot => {
          let user = getDocFromDoc(snapshot)
          this.setState({
            loading: false,
            error: null,
            user,
          })
        }, error => {
          this.setState({
            loading: false,
            error: error,
            user: null,
          })
        })
      } else {
        this.setState({
          loading: false,
          error: null,
          user: null,
        })
      }
    }

    componentWillUnmount() {
      this.unsubscribe()
    }

    render() {
      if (this.state.error) {
        return <Error />
      }

      if (this.state.loading) {
        return <Loading />
      }

      return <WrappedComponent
        user={this.state.user}
        {...this.props}
        />
    }

  }
  componentWithUser.displayName = `withUser(${WrappedComponent.name})`;
  return componentWithUser
}

export default withUser



// WEBPACK FOOTER //
// ./src/data/withCurrentUser.jsx